export var DateUtils;
(function (DateUtils) {
    const _labelTSearch = '{T}';
    DateUtils.localization = {
        day0: 'zondag',
        day1: 'maandag',
        day2: 'dinsdag',
        day3: 'woensdag',
        day4: 'donderdag',
        day5: 'vrijdag',
        days: 'dagen',
        day6: 'zaterdag',
        dayshort0: 'zo',
        dayshort1: 'ma',
        dayshort2: 'di',
        dayshort3: 'wo',
        dayshort4: 'do',
        dayshort5: 'vr',
        dayshort6: 'za',
        month0: 'januari',
        month1: 'februari',
        month2: 'maart',
        month3: 'april',
        month4: 'mei',
        month5: 'juni',
        month6: 'juli',
        month7: 'augustus',
        month8: 'september',
        month9: 'oktober',
        month10: 'november',
        month11: 'december',
        hour: 'uur',
        yesterday: 'gisteren',
        today: 'vandaag',
        tomorrow: 'morgen',
    };
    function minTwoDigits(n) {
        return (n < 10 ? '0' : '') + n;
    }
    DateUtils.minTwoDigits = minTwoDigits;
    function getDaysOffset(date) {
        let simpleDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        let curDate = new Date();
        let simpleCurDate = new Date(curDate.getFullYear(), curDate.getMonth(), curDate.getDate());
        return Math.floor((simpleDate.getTime() - simpleCurDate.getTime()) / 86400000);
    }
    DateUtils.getDaysOffset = getDaysOffset;
    function getDaysOffsetAsString(date) {
        let daysOffset = DateUtils.getDaysOffset(date);
        if (daysOffset === -1) {
            return DateUtils.localization.yesterday;
        }
        else if (daysOffset === 0) {
            return DateUtils.localization.today;
        }
        else if (daysOffset === 1) {
            return DateUtils.localization.tomorrow;
        }
        else {
            return '';
        }
    }
    DateUtils.getDaysOffsetAsString = getDaysOffsetAsString;
    function getDeadlineFormat10(time, divider = ':') {
        if (time > 0) {
            let seconds = Math.floor((time / 1000) % 60);
            let minutes = Math.floor((time / 60000) % 60);
            let hours = Math.floor((time / 3600000));
            return minTwoDigits(hours) + divider + minTwoDigits(minutes) + divider + minTwoDigits(seconds);
        }
        else {
            return '';
        }
    }
    function getDeadlineFormat11(time, label = _labelTSearch + ' dagen') {
        if (time > 172800000) {
            return toLabel(label, Math.floor(time / 86400000));
        }
        else {
            return getDeadlineFormat10(time);
        }
    }
    function parseDeadlineFormat(str, timeleft) {
        const mapObj = {
            '[locDayOrClock]': getDeadlineFormat11(timeleft),
            '[locHours]': minTwoDigits(Math.floor((timeleft / 3600000))),
            '[locMinutes]': minTwoDigits(Math.floor((timeleft / 60000) % 60)),
            '[locSeconds]': minTwoDigits(Math.floor((timeleft / 1000) % 60)),
            '[hours]': Math.floor((timeleft / 3600000)).toString(),
            '[minutes]': minTwoDigits(Math.floor((timeleft / 60000) % 60)),
            '[seconds]': Math.floor((timeleft / 1000) % 60).toString(),
            '[days]': Math.floor(timeleft / 86400000).toString()
        };
        const reg = /\[locDayOrClock\]|\[locHours\]|\[locMinutes\]|\[locSeconds\]|\[hours\]|\[minutes\]|\[seconds\]|\[days\]/gi;
        return str.replace(reg, (matched) => {
            if (mapObj[matched]) {
                return mapObj[matched];
            }
            else {
                return '';
            }
        });
    }
    DateUtils.parseDeadlineFormat = parseDeadlineFormat;
    function toLabel(label, time) {
        return label.replace(_labelTSearch, time.toString());
    }
    function periodLabel(startDay, endDay, addYear = false) {
        let label = '';
        label += startDay.getDate();
        if (startDay.getMonth() !== endDay.getMonth()) {
            label += ' ' + DateUtils.localization['month' + startDay.getMonth()];
        }
        if (addYear && startDay.getFullYear() !== endDay.getFullYear()) {
            label += ' ' + startDay.getFullYear();
        }
        label += ' - ' + endDay.getDate() + ' ' + DateUtils.localization['month' + endDay.getMonth()];
        if (addYear) {
            label += ' ' + endDay.getFullYear();
        }
        return label;
    }
    DateUtils.periodLabel = periodLabel;
    function parseDateFormat(str, date) {
        const locMonth = DateUtils.localization['month' + date.getMonth()];
        const locDate = minTwoDigits(date.getDate());
        const locDayOffset = getDaysOffsetAsString(date);
        const mapObj = {
            '[locDayOffsetOrDate1]': locDayOffset ? locDayOffset : locDate + ' ' + locMonth,
            '[locHours]': minTwoDigits(date.getHours()),
            '[locMinutes]': minTwoDigits(date.getMinutes()),
            '[hours]': date.getHours(),
            '[minutes]': date.getMinutes(),
            '[year]': date.getFullYear().toString().substr(-2),
            '[fullYear]': date.getFullYear(),
            '[date]': date.getDate(),
            '[locDate]': locDate,
            '[month]': minTwoDigits(date.getMonth()),
            '[locDay]': DateUtils.localization["day" + date.getDay()],
            '[locDayShort]': DateUtils.localization["dayshort" + date.getDay()],
            '[locMonth]': locMonth,
        };
        const reg = /\[locDayOffsetOrDate1\]|\[hours\]|\[minutes\]|\[year\]|\[fullYear\]|\[date\]|\[month\]|\[locDate\]|\[locDayShort\]|\[locMonth\]|\[locHours\]|\[locMinutes\]/gi;
        return str.replace(reg, (matched) => {
            if (mapObj[matched]) {
                return mapObj[matched];
            }
            else {
                return '';
            }
        });
    }
    DateUtils.parseDateFormat = parseDateFormat;
})(DateUtils || (DateUtils = {}));
